function initTabs(container) {

	const tabLinks = [...container.querySelectorAll('.tabs__button')]
	const tabContents = [...container.querySelectorAll('.tabs__content')]

	tabLinks.map(link => link.addEventListener('click', clickHandler))

	function clickHandler(event) {
		event.preventDefault()
		const tab = event.currentTarget
		const tabId = tab.getAttribute('data-tab')

		tabLinks.map(el => {
			el.classList.remove('active')
			el.classList.remove('border-top')
		})

		tabContents.map(el => el.classList.remove('active') )

		tab.classList.add('active')
		tab.classList.add('border-top')
		container.querySelector(`#${tabId}`)?.classList.add('active')
	}
}

[...document.querySelectorAll('.tabbed-content')].map(initTabs)